<template>
    <div style="margin: 0px; padding: 0px;">
        <v-cookie></v-cookie>
        <div style="width: 600px; height: 200px; font-size:24px; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto">
            {{msg}}
            <br>
            <el-button type="primary" @click="close()">关闭窗口</el-button>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    data(){
        return{
            msg:'',
            account:this.$route.query.account,
            code:this.$route.query.code,
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted(){
        this.checkCode();
    },
    methods:{
        checkCode(){
            let that = this;
            let data = {'account':this.account,'code':this.code};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/person/checkemailcode.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.msg = "邮箱验证成功";
                }
                else
                {
                    that.msg = res.data.msg;
                }
            })
        },
        close(){
            window.close();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/person/checkemail.vue